'use strict';

const { h } = require('phy');

const OfferAdvertImage = require('../../shared/views/adverts/mpu-advert-image');
const OfferRedemptionText = require('../../shared/views/offer/offer-redemption-text');
const OfferExclusive = require('../../shared/views/offer/offer-exclusive');

function CouponAdvert({ routes, coupon, lazy = true }) {
  if (!coupon) return null;

  const advertUrl = coupon.merchantSlug
    ? routes.merchant.show.replace('{merchantSlug}', coupon.merchantSlug)
    : coupon.destination;

  const ExclusiveElement =
    coupon.isExclusive &&
    OfferExclusive({ className: 'coupon-advert-exclusive' });

  const targetTags = coupon.merchantSlug
    ? {}
    : {
        target: '_blank',
        rel: 'noopener',
      };

  return h(
    'a.coupon-advert',
    {
      href: advertUrl,
      ...targetTags,
      'data-bhc': `CarouselItem:${coupon.id}`,
    },
    [
      h('.coupon-advert-logo', { title: coupon.offerTitle }, [
        OfferAdvertImage({
          className: 'coupon-advert-image',
          alt: `${coupon.merchantName} - ${coupon.offerCallout}`,
          data: coupon.media,
          size: ['w_280'],
          lazy,
        }),
      ]),
      h('.coupon-advert-content', [
        ExclusiveElement,
        h('p.coupon-advert-title', coupon.offerTitle),
        OfferRedemptionText({
          className: 'coupon-advert-type',
          type: coupon.offerType,
        }),
      ]),
    ]
  );
}

module.exports = CouponAdvert;
